<template>
  <section class="qr-view">
    <div class="header">QR Code / Link</div>
    <div class="card">
      <div class="card__qr">
        <QrcodeVue
          id="qr-code"
          class="print"
          :value="qrValue"
          :size="350"
          level="L"
        />
      </div>
      <div class="card__content">
        <div class="card__content__text">
          This is your event QR CODE, for guests to scan with their smartphone camera.
          Download a picture of the QR CODE to use on posters and the like.<br />

            <br />This is your event LINK, to send out in e-mails or text messages:
          <a
            :href="`${hardcodedPath}/${this.$hotelId}`"
            target="_blank"
            style="color: #3f75d1; cursor: pointer; text-decoration: none"
          >
            {{ hardcodedPath }}/{{ this.$hotelId }}
          </a>
        </div>
        <br />
        <div class="card__content__bottom-row">
          <div class="card__content__bottom-row__buttons">
            <a id="download" download="QR.png">
              <ButtonGlobal
                text="DOWNLOAD .PNG"
                size="medium"
                type="white"
                @eventPassed="printAsImage"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ButtonGlobal from "@/components/GlobalComponents/ButtonGlobal.vue";
import QrcodeVue from "qrcode.vue";
import config from "../config";

export default {
  components: {
    ButtonGlobal,
    QrcodeVue,
  },
  data() {
    return {
      hardcodedPath: config.hardcodedPath,
      qrValue: `${config.hardcodedPath}/${this.$hotelId}`,
    };
  },
  methods: {
    printAsPdf() {
      window.print();
    },
    printAsImage() {
      const download = document.getElementById("download");
      const image = document
        .getElementById("qr-code")
        .getElementsByTagName("canvas")[0]
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      download.setAttribute("href", image);
    },
  },
};
</script>

<style scoped>
html {
  background: #efefef;
  height: 100%;
}

.header {
  margin: 30px auto;
  width: 1152px;
  font-size: 36px;
  font-weight: 900;
  color: #707070;
  display: flex;
}

.card {
  margin: 10px auto;
  width: 1152px;
  height: 485px;
  background: #fff;
  display: flex;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
}

.card__qr {
  margin: 70px 0 70px 70px;
}

.card__content {
  margin: 62px 70px 0px 35px;
  font-size: 20px;
  text-align: left;
  width: 631px;
}

.card__content__text {
  font-size: 20px;
  line-height: 30px;
}

.card__content__bottom-row {
  padding-top: 25px;
  display: flex;
}

.card__content__bottom-row__buttons {
  display: flex;
  font-size: 16px;
  justify-content: center;
  width: 100%;
}

</style>
